import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';
import { journeyRadioIllustrationColors as colors } from './constants';
import { JourneyRadioIllustrationColors } from './types';

export const ScheduleEntrySource = ({
  height = 80,
  width = 80,
  backgroundColor = colors.backgroundColor,
  lineColor = colors.lineColor,
  fillColor = colors.fillColor,
}: SvgIconProps & JourneyRadioIllustrationColors) => (
  <SvgIcon width={width} height={height} viewBox="0 0 80 80" fill="none">
    <path
      d="M8 40C8 48.4869 11.3714 56.6263 17.3726 62.6274C23.3737 68.6286 31.5131 72 40 72C48.4869 72 56.6263 68.6286 62.6274 62.6274C68.6286 56.6263 72 48.4869 72 40C72 31.5131 68.6286 23.3737 62.6274 17.3726C56.6263 11.3714 48.4869 8 40 8C31.5131 8 23.3737 11.3714 17.3726 17.3726C11.3714 23.3737 8 31.5131 8 40Z"
      fill={backgroundColor}
    />
    <path
      d="M23.2412 60.2882C23.2412 60.4508 23.6747 60.6119 24.5169 60.7621C25.3591 60.9124 26.5935 61.0489 28.1496 61.1639C29.7058 61.2789 31.5532 61.3701 33.5864 61.4323C35.6197 61.4946 37.7989 61.5266 39.9996 61.5266C42.2004 61.5266 44.3796 61.4946 46.4128 61.4323C48.446 61.3701 50.2934 61.2789 51.8496 61.1639C53.4057 61.0489 54.6402 60.9124 55.4824 60.7621C56.3245 60.6119 56.758 60.4508 56.758 60.2882C56.758 60.1256 56.3245 59.9645 55.4824 59.8143C54.6402 59.664 53.4057 59.5275 51.8496 59.4125C50.2934 59.2975 48.446 59.2063 46.4128 59.1441C44.3796 59.0818 42.2004 59.0498 39.9996 59.0498C37.7989 59.0498 35.6197 59.0818 33.5864 59.1441C31.5532 59.2063 29.7058 59.2975 28.1496 59.4125C26.5935 59.5275 25.3591 59.664 24.5169 59.8143C23.6747 59.9645 23.2412 60.1256 23.2412 60.2882Z"
      fill={fillColor}
    />
    <path
      d="M18.6611 23.3242H61.4467V59.3866H18.6611V23.3242Z"
      fill="white"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M61.4467 34.3266H18.6611V25.2442C18.6611 24.735 18.8634 24.2466 19.2235 23.8866C19.5836 23.5265 20.0719 23.3242 20.5811 23.3242H59.5267C59.7789 23.3242 60.0285 23.3739 60.2615 23.4704C60.4944 23.5669 60.7061 23.7083 60.8844 23.8866C61.0627 24.0649 61.2041 24.2765 61.3006 24.5095C61.3971 24.7424 61.4467 24.9921 61.4467 25.2442V34.3266Z"
      fill={fillColor}
    />
    <path
      d="M61.4459 41.6611V56.9411C61.4459 57.5895 61.1883 58.2114 60.7299 58.6699C60.2714 59.1284 59.6495 59.3859 59.0011 59.3859H41.8867C41.8867 59.3859 51.6659 56.3307 61.4459 41.6611Z"
      fill="white"
    />
    <path
      d="M61.4459 41.6611V56.9411C61.4459 57.5895 61.1883 58.2114 60.7299 58.6699C60.2714 59.1284 59.6495 59.3859 59.0011 59.3859H41.8867C41.8867 59.3859 51.6659 56.3307 61.4459 41.6611Z"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M61.4467 34.3266H18.6611V25.2442C18.6611 24.735 18.8634 24.2466 19.2235 23.8866C19.5836 23.5265 20.0719 23.3242 20.5811 23.3242H59.5267C59.7789 23.3242 60.0285 23.3739 60.2615 23.4704C60.4944 23.5669 60.7061 23.7083 60.8844 23.8866C61.0627 24.0649 61.2041 24.2765 61.3006 24.5095C61.3971 24.7424 61.4467 24.9921 61.4467 25.2442V34.3266Z"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M27.8283 26.9916C27.103 26.9916 26.394 26.7766 25.7909 26.3736C25.1879 25.9706 24.7178 25.3979 24.4403 24.7278C24.1627 24.0577 24.0901 23.3204 24.2316 22.609C24.3731 21.8976 24.7224 21.2442 25.2352 20.7313C25.7481 20.2185 26.4015 19.8692 27.1129 19.7277C27.8243 19.5862 28.5616 19.6588 29.2317 19.9364C29.9018 20.2139 30.4745 20.684 30.8775 21.287C31.2805 21.8901 31.4955 22.5991 31.4955 23.3244"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.6653 26.9916C39.9399 26.9916 39.2309 26.7766 38.6279 26.3736C38.0248 25.9706 37.5548 25.3979 37.2772 24.7278C36.9996 24.0577 36.927 23.3204 37.0685 22.609C37.21 21.8976 37.5593 21.2442 38.0721 20.7313C38.585 20.2185 39.2384 19.8692 39.9498 19.7277C40.6612 19.5862 41.3985 19.6588 42.0686 19.9364C42.7387 20.2139 43.3115 20.684 43.7144 21.287C44.1174 21.8901 44.3324 22.5991 44.3324 23.3244"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.5012 26.9916C52.7759 26.9916 52.0669 26.7766 51.4638 26.3736C50.8607 25.9706 50.3907 25.3979 50.1131 24.7278C49.8356 24.0577 49.763 23.3204 49.9045 22.609C50.0459 21.8976 50.3952 21.2442 50.9081 20.7313C51.4209 20.2185 52.0744 19.8692 52.7857 19.7277C53.4971 19.5862 54.2345 19.6588 54.9046 19.9364C55.5747 20.2139 56.1474 20.684 56.5503 21.287C56.9533 21.8901 57.1684 22.5991 57.1684 23.3244"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6611 40.4385H61.4467"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6611 46.5508H44.2331"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6611 52.6631H44.2331"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.2178 34.3262V59.3862"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.7754 34.3262V59.3862"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.332 34.3262V42.6206"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.8887 34.3262V43.7366"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6611 40.4385H27.2179V46.5505H18.6611V40.4385Z"
      fill={fillColor}
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M27.2178 52.6631H35.7746V59.3863H27.2178V52.6631Z"
      fill={fillColor}
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M35.7754 34.3262H44.3322V40.4382H35.7754V34.3262Z"
      fill={fillColor}
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M61.4459 41.6611C51.6659 56.3307 41.8867 59.3867 41.8867 59.3867C43.2785 56.953 44.1363 54.251 44.4031 51.4601C44.6699 48.6693 44.3395 45.8536 43.4339 43.2003C43.4031 43.1136 43.3965 43.0201 43.4148 42.9299C43.4331 42.8396 43.4756 42.7561 43.5377 42.6882C43.5999 42.6203 43.6794 42.5706 43.7676 42.5444C43.8559 42.5182 43.9496 42.5165 44.0387 42.5395C46.8611 43.3131 55.3779 45.2003 61.4459 41.6611Z"
      fill="white"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.9404 30.6582H46.1652"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.8887 30.6582H57.7791"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.2177 30.6582H22.3281"
      stroke={lineColor}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
